import React from 'react'
import withStyles from 'react-jss'
import classNames from 'classnames'

import { COURSE_COMMENTS_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'

import commentsStyles from './commentsStyles'

const CustomCommentsContainer = withStyles(commentsStyles)(({ classes, children }) => (
  <div
    className={classNames(
      'white-widget',
      'lesson-comments',
      COURSE_COMMENTS_CLASS_NAMES.containerClassName,
      classes.lessonCommentsContainer
    )}
  >
    <span className='discussion'>{I18n.t('shared.common.discussion')}</span>
    {children}
  </div>
))

export default CustomCommentsContainer
